import React, {
  FunctionComponent,
  ReactNode,
} from 'react';
import classnames from 'classnames';

import { capitalize } from '@helpers/humanize';

interface CheckboxGroupProps {
  name: string;
  styleClassNames: { [key: string]: string };
  variantName: string;
  className?: string;
  containerId?: string;
  'aria-labelledby'?: string;
  /** When true, omit role="group" and ARIA labelling (e.g. inside a fieldset with legend). */
  nestedInFieldset?: boolean;
}

const baseName = 'checkbox-group';

const BaseCheckboxGroup: FunctionComponent<CheckboxGroupProps> = (
  props,
) => {
  const {
    'aria-labelledby': ariaLabelledBy,
    children,
    className,
    containerId,
    name,
    nestedInFieldset,
    styleClassNames,
    variantName,
  } = props;

  return (
    <div
      aria-label={!nestedInFieldset && !ariaLabelledBy ? capitalize(name) : undefined}
      aria-labelledby={!nestedInFieldset ? (ariaLabelledBy || undefined) : undefined}
      className={classnames(
        className,
        `bf-${baseName}__${variantName}`, // base-variant class for post consumption styling
        styleClassNames[variantName], // class for css modules
      )}
      id={nestedInFieldset ? undefined : containerId}
      role={nestedInFieldset ? undefined : 'group'}
    >
      {children}
    </div>
  );
};

export default BaseCheckboxGroup;
